import React from 'react'

import './image.scss'

import imagePlaceholder from './../../assets/image-placeholder.jpg'

export const Image = ( { file } ) => {
    return (
        <div className={ `image` } >
            <img
                className={ `image-frame` }
                src={ file ? file.sizes.large : imagePlaceholder }
                alt={ file?.description ?? `` }
                loading="lazy"
                width={ file?.sizes?.["large-width"] }
                height={ file?.sizes?.["large-height"] }
            />
        </div>
    )
}